<app-base-edit-form-modal
  [fields]="fields"
  [id]="id"
  [parentId]="productId"
  [baseService]="customerProductService"
  (saved)="saved()"
>
</app-base-edit-form-modal>
